<template>
  <div class="d-flex flex-column justify-content-center align-items-center text-center vh-100 w-100">
    <div class="flex-grow-1"></div>
    <div class="text-center mx-2">
      <div class="w-50 ml-auto mr-auto mb-5">
        <component :is="maintenanceIcon" />
      </div>

      <strong class="display-1">{{ $t('MaintenancePage.title') }}</strong>
    </div>
    <div class="flex-grow-1"></div>
  </div>
</template>

<script>

import UserMixin from '@shared/mixins/UserMixin'
import store from '@shared/store'

export default {
  mixins: { UserMixin },
  data() {
    return {
      maintenanceIcon: 'maintenanceSvg'
    }
  },
  components: {
    maintenanceSvg: async () => await import(/* webpackChunkName: "maintenance" */ '../assets/icons/maintenance')
  },
  mounted() {
    if (store.state.currentUser) {
      this.logOut()
    }
  }
}
</script>
